import { jsx } from "react/jsx-runtime";
import { SaveToList } from "../SaveToList.js";
import { SavedToList } from "../SavedToList.js";
import { CreateNewList } from "./CreateNewList.js";
const ComponentRenderer = (props) => {
  const {
    bodyContent,
    dispatch,
    enableModernApis,
    locale,
    msStore,
    product,
    setShowSticky,
    showSticky,
    siteValue,
    state
  } = props;
  switch (bodyContent) {
    case "saveToListUI":
      return /* @__PURE__ */ jsx(
        SaveToList,
        {
          dispatch,
          enableModernApis,
          locale,
          msStore,
          product,
          setShowSticky,
          showSticky,
          siteValue,
          state
        }
      );
    case "savedToListUI":
      return /* @__PURE__ */ jsx(
        SavedToList,
        {
          dispatch,
          msStore,
          product,
          state
        }
      );
    case "createNewList":
      return /* @__PURE__ */ jsx(
        CreateNewList,
        {
          dispatch,
          enableModernApis,
          locale,
          msStore,
          product,
          siteValue,
          state
        }
      );
  }
};
export {
  ComponentRenderer
};
